export class TecComPortalResizeAction {
  static readonly type = '[TecComMenu] TecComPortalResizeAction';
}
